module.exports = __webpack_public_path__ + "img/account_info_lo.94538c73.jpg";